import { all, takeEvery, put } from 'redux-saga/effects';
import siteConfig from '@iso/config/site.config';
import actions from './actions';
import { notification } from '@iso/components';
const gaxios = require('gaxios');
gaxios.instance.defaults = {
    baseURL: siteConfig.siteUrl.API_URL
}

export function* getUsers() {
    const res = yield gaxios.request({
        url: 'api/proveedores',
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        yield put({
            type: actions.GET_PROVEEDORES_SUCCESS,
            payload: res.data.proveedores,
        });
    }
}
export function* createUser({ payload }) {
    const res = yield gaxios.request({
        url: 'api/proveedores',
        method: 'POST',
        data: payload,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.GET_PROVEEDORES_REQUEST });
    }
}
export function* editUser({ payload }) {
    const res = yield gaxios.request({
        url: 'api/proveedores/' + payload._id,
        method: 'PUT',
        data: payload,
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.GET_PROVEEDORES_REQUEST });
    }
}
export function* deleteUser({ payload }) {
    const res = yield gaxios.request({
        url: 'api/proveedores/' + payload,
        method: 'DELETE',
        headers: {
            Authorization: localStorage.getItem('access_token'),
            AuthId: localStorage.getItem('id_token')
        }
    });
    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        notification('success', res.data.msg);
        yield put({ type: actions.GET_PROVEEDORES_REQUEST });
    }
}

export default function* rootSaga() {
    yield all([
        yield takeEvery(actions.GET_PROVEEDORES_REQUEST, getUsers),
        yield takeEvery(actions.CREATE_PROVEEDOR_REQUEST, createUser),
        yield takeEvery(actions.EDIT_PROVEEDOR_REQUEST, editUser),
        yield takeEvery(actions.DELETE_PROVEEDOR_REQUEST, deleteUser)
    ]);
}
